module.exports = __webpack_public_path__ + "img/download_google_app.8ed02a49.svg";